export default __webpack_public_path__ + "static/media/close-circle.6266c0d5.svg";